import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import isEmpty from 'lodash/isEmpty';
import cn from 'classnames';
import { getStringDate } from 'utils/getStringDate';
import decline from 'utils/decline';
import Heading from '../Heading';
import ReportLoader from '../ReportLoader';

import { Table, TR } from '../../FullVinReportStyles';
import clock from '../img/clock.svg';

interface IOwnersList {
  type: string;
  start_date: number;
  end_date?: number;
  reason: string;
}

interface IMappedOwners {
  [key: string]: { id: number; title: string; description?: string | number | null };
}

const Owners: FC = observer(() => {
  const {
    checksStore: {
      owners: { data, progress_ok, valid_owner_count },
      reportOwnerCount,
    },
  } = useStores();

  const typeDescription: { [key: string]: string } = {
    LEGAL: 'Юридическое лицо',
    PERSON: 'Физическое лицо',
    PERSONLEGAL: 'ИП (Индивидуальный предприниматель)',
    UNKNOWN: 'неизвестно',
    NONE: 'неизвестно',
  };

  const isTypeDescription = ['UNKNOWN', 'NONE'];

  const mappedOwners = (item: IOwnersList): IMappedOwners => {
    return {
      type: {
        id: 0,
        title: 'Тип владельца',
        description: isTypeDescription.includes(item.type) ? null : typeDescription[item.type],
      },
      start_date: {
        id: 1,
        title: 'Период владения',
        description:
          item.start_date &&
          `${getStringDate(item.start_date)} ${
            item.end_date ? `- ${getStringDate(item.end_date)}` : ''
          }`,
      },
      reason: {
        id: 2,
        title: 'Причина окончания',
        description: item.reason,
      },
    };
  };

  const renderHeadingDescription = () => {
    if (isEmpty(data) && !progress_ok) return 'История владения';

    return (
      reportOwnerCount &&
      `${reportOwnerCount} ${decline(reportOwnerCount, [
        'владелец',
        'владельца',
        'владельцев',
      ])} по ПТС`
    );
  };

  const renderOwners = () => {
    if (!isEmpty(data)) {
      return (
        <Table>
          <tbody>
            {data.map((owner: IOwnersList) => {
              return Object.keys(mappedOwners(owner)).map((item, index, array) => {
                const { title, description } = mappedOwners(owner)[item];
                const isFirst = index === 0;

                return (
                  <TR key={index} className={cn(!description && 'fake-hide')}>
                    <td className={cn(isFirst && 'setPadding', 'gray', !description && 'hidden')}>
                      {title}
                    </td>
                    <td>{description}</td>
                  </TR>
                );
              });
            })}
          </tbody>
        </Table>
      );
    }

    return <ReportLoader />;
  };

  return (
    <section className="section-box">
      <Heading
        icon={<img src={clock} alt="icon-clock" />}
        descr={renderHeadingDescription()}
        beCarefulState={!isEmpty(data) && !valid_owner_count}
      />
      {renderOwners()}
    </section>
  );
});

export default Owners;
